// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M11.5 2.5H7C5.35 2.5 4.25 3.35 4.25 4.65C4.25 5.1 4.45 5.65 4.8 6M9 8C10.8 8 12 9.1 12 10.5C12 12.05 10.75 13 9 13H4.5',
  'M2.5 8H13.5',
];
